//function to show and hide the divs' based on the type

function ShowHideDiv()
{
  var type = document.getElementById("CustomerType").value;
  if (type == 'Dealer')
  {
    document.getElementById("div1").style.display = "block";
    document.getElementById("div2").style.display = "block";
    //document.getElementById("alert").innerHTML = '';
  }
  else if (type == 'Distributor')
  {
    document.getElementById("div1").style.display = "none";
    document.getElementById("div2").style.display = "block";
    //document.getElementById("alert").innerHTML = '';
  }
  else 
  {
    document.getElementById("div1").style.display = "none";
    document.getElementById("div2").style.display = "none"; 
    //document.getElementById("alert").innerHTML = '';
  }
  
}

//function to submit the form data to the API

function DoSubmit(e)
{
var firstName = document.getElementById('FirstName').value;
var lastName = document.getElementById('LastName').value;
var email = document.getElementById('Email').value;
var cusType = document.getElementById('CustomerType').value;
var disName = document.getElementById('DistributorName').value;
var disBranch = document.getElementById('DistributorBranch').value;
/*var disBranchAdd = document.getElementById('DistributorBranchAddress').value;
var disContact = document.getElementById('DistributorContact').value;
var disContactEmail = document.getElementById('DistributorContactEmail').value;*/
var shopName = document.getElementById('name').getAttribute("data-val");
var requestURL = document.getElementById('requestURL').getAttribute("data-val");
document.getElementById('loader_account_request').style.display = 'block'; 
  
if (cusType == 'Dealer')
{

var dealPartnerID = document.getElementById('Dealer').value;
var dealName = document.getElementById('DealerName').value;
var dealAdd = document.getElementById('DealerAddress').value;
/*var dealContactName = document.getElementById('DealerContactName').value;
var dealContactEmail = document.getElementById('DealerContactEmail').value;*/
//if (dealName == '' || dealAdd == '' || dealContactName == '' || dealContactEmail == '' || disName == '' || disBranchAdd == '' || disContact == '' || disContactEmail == '')
if (dealName == '' || dealAdd == '' ||  disName == '' )
{
document.getElementById('DealerName').required = true
document.getElementById('DealerAddress').required = true
//document.getElementById('DealerContactName').required = true
//document.getElementById('DealerContactEmail').required = true
document.getElementById('DistributorName').required = true
/*document.getElementById('DistributorBranchAddress').required = true
document.getElementById('DistributorContact').required = true
document.getElementById('DistributorContactEmail').required = true*/
//console.log('Executed')
document.getElementById('loader_account_request').style.display = 'none'; 
}
else 
{
var accountRequest = {};
accountRequest['shop'] = shopName;
accountRequest['first_name'] = firstName;
accountRequest['last_name'] = lastName;
accountRequest['email'] = email;
accountRequest['type'] = cusType;
accountRequest['dealer_hvacid'] = dealPartnerID;
accountRequest['dealer_name'] = dealName;
accountRequest['dealer_address'] = dealAdd;
accountRequest['dealer_contact_name'] = '';
accountRequest['dealer_contact_email'] = '';
accountRequest['distributor_name'] = disName;
accountRequest['distributor_branch'] = disBranch;
accountRequest['distributor_address'] = '';
accountRequest['distributor_contact'] = '';
accountRequest['distributor_contact_email'] = '';
var request = JSON.stringify(accountRequest); 
console.log('request' +request);
//debugger;
var storeAuthId = document.getElementById('clientID').getAttribute("data-val");
var storeAuthKey = document.getElementById('clientSecret').getAttribute("data-val");  
var authorizationBasic = window.btoa(storeAuthId + ':' + storeAuthKey);
  
  //Sending Request to Azure Webapp
  let xhrdeal = new XMLHttpRequest(); 
  let urldeal = requestURL; 
  // open a connection 
  xhrdeal.open("POST", urldeal, true); 

  // Set the request header i.e. which type of content you are sending 
  xhrdeal.setRequestHeader("Content-Type", "application/json"); 
  xhrdeal.setRequestHeader('Authorization', 'Basic ' + authorizationBasic);
  xhrdeal.setRequestHeader('Accept', 'application/json');  
  //debugger;
  
  // Sending data with the request 
  xhrdeal.send(request); 
  //debugger;
  
  xhrdeal.onreadystatechange = function () 
  {  
    var state = xhrdis.readyState;
    console.log('readystate' +state);
    var status = xhrdis.status;
    console.log('status' +status);
    //debugger;
    //console.log('readyexecuted');
    
    if (state != 4)
     { 
     document.getElementById('loader_account_request').style.display = 'none';      
     }
    
    if (xhrdeal.readyState === 4 && xhrdeal.status === 200) 
       {  
    //debugger;
    //console.log('readyexecuted');
    var response = xhrdeal.responseText;
    console.log('Response' +response); 
    document.getElementById('loader_account_request').style.display = 'none'; 
    document.getElementById('FirstName').value = ''
    document.getElementById('LastName').value = ''
    document.getElementById('Email').value = ''
    document.getElementById('CustomerType').value = ''
    document.getElementById('Dealer').value = ''
    document.getElementById('DealerName').value = ''
    document.getElementById('DealerAddress').value = ''
    //document.getElementById('DealerContactName').value = ''
    //document.getElementById('DealerContactEmail').value = ''
    document.getElementById('DistributorName').value = ''
    document.getElementById('DistributorBranch').value = ''
    /*document.getElementById('DistributorBranchAddress').value = ''
    document.getElementById('DistributorContact').value = ''
    document.getElementById('DistributorContactEmail').value = ''*/
       }
    
    };
  
  }
 
}
else if (cusType == 'Distributor')
{
document.getElementById('DealerName').required = false;
document.getElementById('DealerAddress').required = false;
//document.getElementById('DealerContactName').required = false;
//document.getElementById('DealerContactEmail').required = false;
//if (disName == '' || disBranchAdd == '' || disContact == '' || disContactEmail == '')
if (disName == '')
{
document.getElementById('DistributorName').required = true
/*document.getElementById('DistributorBranchAddress').required = true
document.getElementById('DistributorContact').required = true
document.getElementById('DistributorContactEmail').required = true*/
//console.log('Executed')
document.getElementById('loader_account_request').style.display = 'none'; 
}
else 
{
var accountRequest = {};
accountRequest['shop'] = shopName;
accountRequest['first_name'] = firstName;
accountRequest['last_name'] = lastName;
accountRequest['email'] = email;
accountRequest['type'] = cusType;
accountRequest['dealer_hvacid'] = '';
accountRequest['dealer_name'] = '';
accountRequest['dealer_address'] = '';
accountRequest['dealer_contact_name'] = '';
accountRequest['dealer_contact_email'] = '';
accountRequest['distributor_name'] = disName;
accountRequest['distributor_branch'] = disBranch;
accountRequest['distributor_address'] = '';
accountRequest['distributor_contact'] = '';
accountRequest['distributor_contact_email'] = '';
var request = JSON.stringify(accountRequest); 
console.log('request' +request);
//debugger;
var storeAuthId = document.getElementById('clientID').getAttribute("data-val");
var storeAuthKey = document.getElementById('clientSecret').getAttribute("data-val");  
var authorizationBasic = window.btoa(storeAuthId + ':' + storeAuthKey);
  
//Sending Request to Azure Webapp
  let xhrdis = new XMLHttpRequest(); 
  let urldis = requestURL; 
  // open a connection 
  xhrdis.open("POST", urldis, true); 

  // Set the request header i.e. which type of content you are sending 
  xhrdis.setRequestHeader("Content-Type", "application/json"); 
  xhrdis.setRequestHeader('Authorization', 'Basic ' + authorizationBasic);
  xhrdis.setRequestHeader('Accept', 'application/json');
  //debugger;
 
  xhrdis.onreadystatechange = function () 
  {  
    var state = xhrdis.readyState;
    console.log('readystate' +state);
    var status = xhrdis.status;
    console.log('status' +status);    
    //debugger;
    //console.log('readyexecuted');
    
   if (state != 4)
     {
       
     document.getElementById('loader_account_request').style.display = 'none';  
       
     }
    
    if (xhrdis.readyState === 4 && xhrdis.status === 200) 
       { 
    //debugger;
    //console.log('readyexecuted');
    document.getElementById('loader_account_request').style.display = 'none'; 
    var response = xhrdis.responseText;
    console.log('Response' +response);
    document.getElementById('FirstName').value = ''
    document.getElementById('LastName').value = ''
    document.getElementById('Email').value = ''
    document.getElementById('CustomerType').value = ''
    document.getElementById('DistributorName').value = ''
    document.getElementById('DistributorBranch').value = ''
    /*document.getElementById('DistributorBranchAddress').value = ''
    document.getElementById('DistributorContact').value = ''
    document.getElementById('DistributorContactEmail').value = ''*/
       }
    
     };
  
   // Sending data with the request 
   xhrdis.send(request);    
   //debugger;  
  
  }

}

else 
{
  document.getElementById('DealerName').required = false;
  document.getElementById('DealerAddress').required = false;
  /*document.getElementById('DealerContactName').required = false;
  document.getElementById('DealerContactEmail').required = false;*/
  document.getElementById('DistributorName').required = false;
  /*document.getElementById('DistributorBranchAddress').required = false;
  document.getElementById('DistributorContact').required = false;
  document.getElementById('DistributorContactEmail').required = false;*/
  document.getElementById('loader_account_request').style.display = 'none'; 
  //var message = "*Please select a customer type to proceed"
  //document.getElementById("alert").innerHTML = message;

}

}



